import AccountAdd from '@/pages/administration/AccountAdd.vue'
import AccountDetail from '@/pages/administration/AccountsListDetailPage.vue'
import AccountEdit from '@/pages/administration/AccountEdit.vue'
import Accounts from '@/pages/administration/AccountsPage.vue'
import Company from '@/pages/administration/CompanyPage.vue'
import ListCompanies from '@/pages/administration/CompaniesList.vue'
import ListUsers from '@/pages/administration/UsersList.vue'

export default [
  {
    path: '/administration/accountAdd/:type',
    component: AccountAdd
  },
  {
    path: '/administration/accountDetail/:idUserAccount',
    component: AccountDetail
  },
  {
    path: '/administration/accountEdit/:idUserAccount',
    component: AccountEdit
  },
  {
    path: '/administration/accounts/',
    component: Accounts
  },
  {
    path: '/administration/company/:idAccount',
    component: Company
  },
  {
    path: '/administration/listCompanies/',
    component: ListCompanies
  },
  {
    path: '/administration/listUsers/',
    component: ListUsers
  }
]



// WEBPACK FOOTER //
// ./src/routes/administration.js